export default {
    authors: [],
    courses: [],
    ajaxCallsInProgress: 0,
    timeSheets: [],
    myProjects: [],
    projects: [],
    me: null,
    users: null,
    tasks: [],
    taskTypes: [],
    currentDate: null,
    projectStates: [],
    roles: []
};


/** WEBPACK FOOTER **
 ** ./src/reducers/initialState.js
 **/